export default interface IRequestedTokensResponse {
	token: string,
	fuel2token: string,
}

export const defaultRequestedTokensResponse: IRequestedTokensResponse = {
	token: "",
	fuel2token: "",
}
